import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-5" />} data-id="element-4" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-7" />} data-id="element-6" />
        <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-9" />} data-id="element-8" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}